import React from 'react'
import {Icon} from '@chakra-ui/react'

const BurgerIcon = (props) => {
    return (
        <Icon viewBox="0 0 40 40" {...props}>
            <path
                d="M38.0601 7.87979H1.9399C1.42295 7.87979 1 7.45684 1 6.9399C1 6.42295 1.42295 6 1.9399 6H38.0601C38.577 6 39 6.42295 39 6.9399C39 7.45684 38.577 7.87979 38.0601 7.87979Z"
                fill="currentColor"
            />
            <path
                d="M38.0601 20.8786H1.9399C1.42295 20.8786 1 20.4556 1 19.9387C1 19.4217 1.42295 18.9988 1.9399 18.9988H38.0601C38.577 18.9988 39 19.4217 39 19.9387C39 20.4556 38.577 20.8786 38.0601 20.8786Z"
                fill="currentColor"
            />
            <path
                d="M38.0601 33.8867H1.9399C1.42295 33.8867 1 33.4638 1 32.9468C1 32.4299 1.42295 32.0069 1.9399 32.0069H38.0601C38.577 32.0069 39 32.4299 39 32.9468C39 33.4638 38.577 33.8867 38.0601 33.8867Z"
                fill="currentColor"
            />
        </Icon>
    )
}

export default BurgerIcon
